var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.tags, function (tag) {
      return _c("el-tag", { key: tag[_vm.keyField] }, [
        _vm._v(" " + _vm._s(tag[_vm.valueField]) + " "),
      ])
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }